<template>
  <div>
    <div class="line_loading"><i class="fas fa-spinner fa-spin"></i></div>
  </div>
</template>

<script>
import { LINE_LIFF_PROFILE_REGISTRATION } from '@/store/line/actions'
import liff from '@line/liff'

export default {
  name: 'LineLiffProfileRegist',
  data () {
    return {
      params: null,
      liffId: null
    }
  },
  methods: {
    getQueryStrings () {
      try {
        const search = document.location.search.substring(1)
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        this.params = params
        if ('liffid' in params) {
          this.liffId = params.liffid
        }
      } catch (e) {
      }

      this.initLiff()
    },
    initLiff () {
      liff.init({
        liffId: this.liffId
      }).then(() => {
        const accessToken = liff.getAccessToken()
        this.params.access_token = accessToken
        const idToken = liff.getIDToken()
        this.params.id_token = idToken
        this.regist()
      })
    },
    regist () {
      this.$store.dispatch(LINE_LIFF_PROFILE_REGISTRATION, this.params)
        .then((data) => {
          location.replace(data.url)
        })
        .catch((error) => {
          if (error.errorStatus === 400) {
            location.replace(error.errorData.url)
          }
        })
    }
  },
  created () {
    this.getQueryStrings()
  }
}
</script>
